// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"72":"bf790b11","303":"ebeac20a","865":"5d23003e"}[chunkId] + ".css";
};